import type { InjectionKey } from 'vue';

export type AttributeContext = {
  labelColumn: boolean;
};

export const attributeContextKey: InjectionKey<AttributeContext | null> =
  Symbol('ds-attribute-context');
